import wollokMobileImg from './imgs/wollok_mobile_icon.jpeg'
import laboFuncionesImg from './imgs/labo_funciones_icon.png'
import linterImg from './imgs/linter.png'
import autocompleteImg from './imgs/autocomplete.png'
import testRunnerImg from './imgs/test_runner.png'
import consoleImg from './imgs/console.png'
import quickFixesImg from './imgs/quickFixes.png'
import dynamicDiagramImg from './imgs/dynamicDiagram.png'
import staticDiagramImg from './imgs/staticDiagram.png'
import debuggerImg from './imgs/debugger.png'
import typeSystemImg from './imgs/typeSystem.png'
import gameWebImg from './imgs/gameWeb.png'

export default {
    wollokMobileImg,
    laboFuncionesImg,
    linterImg,
    autocompleteImg,
    testRunnerImg,
    consoleImg,
    quickFixesImg,
    dynamicDiagramImg,
    staticDiagramImg,
    debuggerImg,
    typeSystemImg,
    gameWebImg,
}